// extracted by mini-css-extract-plugin
module.exports = {"contact":"Contact_contact__1uOxB","heading":"Contact_heading__1Veb3"};